import {queueDetailConfigTa72} from "../config/queueDetailTa72";
import {queueDetailConfigPyramid} from "../config/queueDetailPyramid";
import {queueDetailConfigUnu} from "../config/queueDetailUnu";
import {queueDetailConfigAmazonLocker} from "../config/queueDetailAmazonLocker";

export function resolveClientConfig(client) {
    if(client === 'sparkasse-offenburg') {
        return queueDetailConfigTa72;
    }

    if(client === 'b2x') {
        return queueDetailConfigTa72;
    }

    if(client === 'unu') {
        return queueDetailConfigUnu;
    }

    if(client === 'amazon-locker') {
        return queueDetailConfigAmazonLocker;
    }

    if(client === 'pyramid') {
        return queueDetailConfigPyramid;
    }

    return null;
}
